import { useAvailabilities } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/Availabilities'
import { useSourcesVisibility } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useSourcesVisibility'

export const useChartVisibility = () => {
  const { availabilities } = useAvailabilities()
  const sourcesVisibility = useSourcesVisibility()

  const canSeeAgreements = sourcesVisibility.canSeeAgreements
  const canSeeEmployeeExpenses =
    availabilities.modules.expenses && sourcesVisibility.canSeeEmployeeExpenses
  const canSeeLaborCosts = !availabilities.seePayrollLanding && sourcesVisibility.canSeeLaborCosts

  return {
    canSeeAgreements,
    canSeeEmployeeExpenses,
    canSeeLaborCosts,
  }
}
